export const CROSS_VISITS_MAPS_SETTINGS = 'crossVisitsMapsSettings';
